import { axios } from './ServiceUtils';

const getChatLabels = async locale =>
  await axios
    .get('api/contact-slider-labels', {
      headers: {
        'Content-Language': locale,
      },
    })
    .then(response => response.data);

export { getChatLabels };
